<template>
  <StatCard
    :title="cardTitle"
    :value="formattedValue"
    icon="shopping_cart"
    icon-class="order-icon"
    :trend="statsComparison.trend"
    :percentage="statsComparison.percentage"
    :comparison-period="comparisonPeriod"
  />
</template>

<script>
import StatCard from "./StatCard.vue";
import millify from "millify";

export default {
  name: "OrdersCard",
  components: {
    StatCard
  },
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    dateRange: {
      type: String,
      default: 'last30days'
    },
    statsComparison: {
      type: Object,
      default: () => ({ percentage: 0, trend: 'neutral' })
    },
    comparisonPeriod: {
      type: String,
      default: 'previous_period'
    }
  },
  computed: {
    formattedValue() {
      return this.value ? millify(Number(this.value)) : "0";
    },
    cardTitle() {
      switch (this.dateRange) {
        case 'today':
          return "Today's Orders";
        case 'yesterday':
          return "Yesterday's Orders";
        case 'last7days':
          return "7-Day Orders";
        case 'last30days':
          return "30-Day Orders";
        case 'last90days':
          return "90-Day Orders";
        default:
          return "Period Orders";
      }
    }
  }
};
</script> 